import angular from 'angular'
import template from './template.html'

angular.module('nominas.nomina')
  .component('nominaTimbresCancelarConfirmar', {
    template: template,
    controller: NominaTimbresCancelarConfirmarComponent,
    bindings: {
      idProyecto: '<',
      idNomina: '<',
      data: '<',
      omitidos: '<',
      onClose: '&',
    },
  })

function NominaTimbresCancelarConfirmarComponent () {
  let $ctrl = this

  $ctrl.$onInit = $onInit
  $ctrl.aceptar = aceptar
  $ctrl.cancelar = cancelar

  function $onInit () {
    $ctrl.notas = ''
    $ctrl.uuid_relacionado = null
    $ctrl.motivosCancelacion = [
      { id: 1, descripcion: 'Comprobante emitido con errores con relación', motivo: '01' },
      { id: 2, descripcion: 'Comprobante emitido con errores sin relación', motivo: '02' },
      { id: 3, descripcion: 'No se llevó a cabo la operación', motivo: '03' },
      { id: 4, descripcion: 'Operación nominativa relacionada con la factura global', motivo: '04' },
    ]
  }

  function aceptar () {
    $ctrl.onClose({
      $event: {
        data: {
          motivo: $ctrl.motivo,
          uuid_relacionado: $ctrl.uuid_relacionado,
          cancelado_notas: $ctrl.notas,
        },
      },
    })
  }

  function cancelar () {
    $ctrl.onClose({ $event: {} })
  }
}



// WEBPACK FOOTER //
// ./src/nominas/nomina/components/timbres/cancelar/confirmar/component.js